import { useMutation } from '@tanstack/react-query';

import { completeSignUpSurvey } from 'api/user/completeSignUpSurvey';

export const useCompleteSignUpSurvey = () =>
    useMutation({
        mutationFn: completeSignUpSurvey,
    });
